var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.styles},[(_vm.image)?_c('img',{staticClass:"risk-icon__image",attrs:{"src":_vm.source,"alt":_vm.description}}):_c('i',{staticClass:"risk-icon__icon"},[_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.description))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }